export const handleFontSizeChange =
    (referenceWidth: number, fixedFontSize?: string) => () => {
        if (fixedFontSize) {
            document.documentElement.style.fontSize = fixedFontSize;
            return;
        }
        const size = Math.round((16 / referenceWidth) * window.innerWidth);
        document.documentElement.style.fontSize = `${size}px`;
    };
